var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"block w-full h-full",attrs:{"to":"/"}},[_c('img',{staticClass:"block w-full h-full",attrs:{"src":require("../../assets/images/logo.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }